enum SpatialDimension {
  _2D = "2D",
  _3D = "3D",
}

export default SpatialDimension;
